import { configureStore } from '@reduxjs/toolkit'
import srpData from '../reducers/index'

export default function initStore(initialState) {
    const store = configureStore({
        reducer: srpData,
        preloadedState: initialState,
        devTools: false
    })

    return store
}
